import type { AxiosRequestConfig } from 'axios';
import axios from 'axios';

export type PermissionsType = {
  new: boolean;
  confirm: boolean;
  deny: boolean;
  cancel: boolean;
  attempted: boolean;
  time_change: boolean;
};

const getDashboardPermissions = async (
  dashboardId: string,
  appointmentId: string,
) => {
  const config: AxiosRequestConfig = {
    url: `/external/dash/${dashboardId}/permissions/${appointmentId}`,
    method: 'get',
  };

  const { data } = await axios.request<PermissionsType>(config);

  return data;
};

export default getDashboardPermissions;
